// "USD — US Dollar", from `Intl` so the ~30 switchable currencies need no hand-kept name list.

let names: Intl.DisplayNames | null = null;

export function currencyLabel(code: string): string {
  names ??= new Intl.DisplayNames(['en-GB'], { type: 'currency' });
  const name = names.of(code);
  return name && name !== code ? `${code} — ${name}` : code;
}
